import { render, staticRenderFns } from "./RegionSearch.vue?vue&type=template&id=b3fcf018&scoped=true&"
import script from "./RegionSearch.vue?vue&type=script&lang=js&"
export * from "./RegionSearch.vue?vue&type=script&lang=js&"
import style0 from "./RegionSearch.vue?vue&type=style&index=0&id=b3fcf018&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3fcf018",
  null
  
)

export default component.exports